import * as actionTypes from './actionType';
import { I_VocationFilterSelected, I_VocationFilter } from './interface';

const VocationFilterStore = <I_VocationFilter>{
    PriceMax: 1,
    PriceMin: 0,
    DestinationList: [],
    TrafficTypeList: [],
    SubjectList: [],
    ItineraryList: [],
    LevelList: [],
    CityZoneList: [],
    LightboxDestination: [],
};

const VocationFilterSelected = <I_VocationFilterSelected>{
    // 用戶篩選的值
    // Keyword: '',
    selectedPrices: [],
    selectedDestinationID: [],
    selectedTrafficTypes: [],
    selectedProductGroups: [],
    selectedItineraries: [],
    selectedHotelLevels: [],
    selectedCityZones: [],
    Page: 1,
    PageSize: 10,
    SortType: '', // 空字串轉成網址api後傳到後端會解讀成null
};
export const VocationReducer = (state = Vocation, action: any) => {
    switch (action.type) {
        case actionTypes.SET_VOCATION_SUCCESS:
            return {
                ...state,
                VocationFilterStore: { ...state.VocationFilterStore, ...action.payload },
            };
        // return { ...state, [action.payload.filterTag]: action.payload };
        case actionTypes.SET_VOCATION_SELECTED: // 傳入 { datafilter的key : 選到的值 }
            return {
                ...state,
                VocationFilterSelected: { ...state.VocationFilterSelected, ...action.payload },
            };
        case actionTypes.SET_VOCATION_LIGHTBOXDEST:
            return {
                ...state,
                VocationFilterStore: { ...state.VocationFilterStore, ...action.payload },
            };
        default:
            return state;
    }
};
const Vocation = {
    VocationFilterStore,
    VocationFilterSelected,
};
